module.exports = __webpack_public_path__ + "img/log.83ea6cf6.svg";